import { useEffect, useState } from "react";

import useSideBladeStore from "@store/useSideBladeStore";
import { useEscapeKey } from "@hooks/useEscapeKey";
import { useTimeoutRef } from "@hooks/useTimeoutRef";
import { cn } from "@utils/tailwind.util";

export function SideBlade() {
  const { isOpen, body, closeSideBlade } = useSideBladeStore();
  const [shouldRender, setShouldRender] = useState(false);
  const [visible, setVisible] = useState(false);
  const { schedule: scheduleAnimation } = useTimeoutRef();

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true); // mount
      scheduleAnimation(() => setVisible(true), 50);
    } else {
      setVisible(false); // launch animation
      scheduleAnimation(() => setShouldRender(false), 500);
    }
  }, [isOpen, scheduleAnimation]);

  useEscapeKey({ callback: closeSideBlade, enabled: isOpen });

  if (!shouldRender) return null;

  return (
    <div
      className={cn(
        "fixed top-0 right-0 h-screen w-full bg-white dark:bg-gray-800 shadow-lg overflow-y-scroll transition-transform duration-500 z-[100]",
        visible ? "translate-x-0" : "translate-x-full"
      )}
    >
      {body}
    </div>
  );
}
